import { useState } from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';

export const useStickyBanner = (target: React.MutableRefObject<HTMLFormElement | HTMLDivElement>) => {
  const [ isBannerVisible, setIsBannerVisible ] = useState(true);

  useIntersectionObserver(
    ([ intersect ]) => {
      setIsBannerVisible(!intersect.isIntersecting);
    },
    [ target ],
    { threshold: [ 1, 0 ] }
  );


  return isBannerVisible;
};
